module.exports = {"name":"Projects","parameters":[{"name":"enableV1PortfolioProjects","valid":[false,true],"value":false}]}